import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
`;

export const StyledButton = styled(Button)`
  border: unset;
  background-color: transparent;
  font-size: large;
  color: ${({ theme }) => theme.colors.black};
`;
